var _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEthLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 10,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_800_1076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5003 2.5L10.4109 2.84183V12.7601L10.5003 12.8605L14.5926 10.1391L10.5003 2.5Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 2.5L6.40771 10.1391L10.5001 12.8605V8.04643V2.5Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5004 13.7323L10.45 13.8015V17.3345L10.5004 17.5001L14.5952 11.0124L10.5004 13.7323Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 17.5001V13.7323L6.40771 11.0124L10.5001 17.5001Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5002 12.8609L14.5925 10.1395L10.5002 8.04688V12.8609Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40771 10.1395L10.5001 12.8609V8.04688L6.40771 10.1395Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_800_1076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 15,
    fill: "white",
    transform: "translate(3.83325 2.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthLogo);
export default __webpack_public_path__ + "static/media/ethLogo.3ef388bcbc4215ace7232c850557b901.svg";
export { ForwardRef as ReactComponent };